'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002418 from "./presto.-Register-Page-View$$anon$18.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00244 from "./presto.-Register-Page-View$$anon$4.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024 from "./presto.types$-Single-App-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$3(outer) {
  this.buY = null;
  this.buQ = null;
  this.buR = false;
  this.buZ = null;
  this.bv0 = false;
  this.bv3 = null;
  this.buW = null;
  this.buX = false;
  this.buS = null;
  this.buT = false;
  this.buU = null;
  this.buV = false;
  this.bv1 = false;
  this.bv2 = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.buY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bv3 = "SingleAppToken";
}
export { $c_Lpresto_RegisterPageView$$anon$3 as $c_Lpresto_RegisterPageView$$anon$3 };
$p = $c_Lpresto_RegisterPageView$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$3;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$3() {
}
export { $h_Lpresto_RegisterPageView$$anon$3 as $h_Lpresto_RegisterPageView$$anon$3 };
$h_Lpresto_RegisterPageView$$anon$3.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.buY;
});
$p.M = (function() {
  if ((!this.buR)) {
    this.buQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.buR = true;
  }
  return this.buQ;
});
$p.O = (function() {
  if ((!this.bv0)) {
    this.buZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bv0 = true;
  }
  return this.buZ;
});
$p.D = (function() {
  return this.bv3;
});
$p.t = (function() {
  if ((!this.buX)) {
    this.buW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.buX = true;
  }
  return this.buW;
});
$p.N = (function() {
  if ((!this.buT)) {
    this.buS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().GU(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().GU())), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00244.$c_Lpresto_RegisterPageView$$anon$4(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.buT = true;
  }
  return this.buS;
});
$p.Q = (function() {
  if ((!this.buV)) {
    this.buU = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002418.$c_Lpresto_RegisterPageView$$anon$18();
    this.buV = true;
  }
  return this.buU;
});
$p.v = (function() {
  if ((!this.bv2)) {
    this.bv1 = false;
    this.bv2 = true;
  }
  return this.bv1;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee121) => ((p) => \u03b4scrutinee121.adK(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024.$m_Lpresto_types$SingleAppToken$())));
});
var $d_Lpresto_RegisterPageView$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$3, "presto.RegisterPageView$$anon$3", ({
  Qa: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$3 as $d_Lpresto_RegisterPageView$$anon$3 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$3.js.map
